<template>
    <div class="dropdown-menu" aria-labelledby="menu-btn">
        <div class="m-dropdown-menu__logo">
                <router-link to="/">
                    <div class="m-dropdown-menu__logo-img">
                        <img src="/img/motivate-icon.png" alt="Motivate">
                    </div>
                </router-link>
            </div>
        <ul class="m-dropdown-menu__nav">
                <router-link tag="li" :to="{name:'products'}" class="m-menu__item "exact>
                    <a class="m-menu__link ">
                        <span> Producten </span>
                    </a>
                </router-link>

                <!--<router-link tag="li" :to="{name:'product-create'}" class="m-menu__item ">-->
                    <!--<a class="m-menu__link ">-->
                        <!--<span> Product toevoegen </span>-->
                    <!--</a>-->
                <!--</router-link>-->

                <router-link tag="li" :to="{name:'product-attributes'}" class="m-menu__item " exact>
                    <a class="m-menu__link ">
                        <span> Attributen </span>
                    </a>
                </router-link>
                <router-link tag="li" :to="{name:'testers'}" class="m-menu__item " exact>
                    <a class="m-menu__link ">
                        <span> Controleurs </span>
                    </a>
                </router-link>
                <router-link tag="li" :to="{name:'defects'}" class="m-menu__item " exact>
                    <a class="m-menu__link ">
                        <span> Defecten </span>
                    </a>
                </router-link>

                <router-link tag="li" :to="{name:'export'}" class="m-menu__item " exact>
                    <a class="m-menu__link ">
                        <span> Export </span>
                    </a>
                </router-link>
             </ul>
        </div>

</template>

<style scope lang="scss">
    .m-aside .m-aside-wrapper .m-aside-nav li.router-link-active:not(.router-link-exact-active) {
        background: transparent;
    }
</style>

<script>
    import {mapGetters} from 'vuex'
    import AdminMenu from './../components/AdminMenu'

    export default {
        components: {
            AdminMenu,
        },
        data() {
            return {
                isVisible: true,
                showMenu: false
            }
        },
        computed: {
            ...mapGetters('users', [
                'getMe'
            ]),
            ...mapGetters('root', [
                'getMockedCompany'
            ]),

        },
        created() {
        },
    }
</script>